/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActionStatus = "Completed" | "NA" | "Open" | "Removed" | "%future added value";
export type AdmissionType = "InPatient" | "Observation" | "OutPatient" | "%future added value";
export type BarrierStatus = "Open" | "Resolved" | "%future added value";
export type BedRequestStatus = "Anticipated" | "AnticipatedDischarge" | "AnticipatedUnitTransfer" | "Cancelled" | "CheckedIn" | "DischargeOrderWithDelay" | "Discharged" | "IntentToAdmit" | "Pending" | "PendingDischarge" | "PendingUnitTransfer" | "Ready" | "ReadyForDischarge" | "ReadyForUnitTransfer" | "Transferred" | "%future added value";
export type BedRequestType = "Admission" | "UnitTransfer" | "%future added value";
export type DepartmentType = "AdmissionSource" | "Unit" | "%future added value";
export type MilestoneStatus = "Completed" | "NA" | "Open" | "Removed" | "%future added value";
export type OffsetBasis = "Admission" | "Discharge" | "Variable" | "%future added value";
export type OwnerMessageStatus = "ACKNOWLEDGED" | "NEEDS_REASSIGNMENT" | "UNACKNOWLEDGED" | "%future added value";
export type ProgressionIndicator = "AtRisk" | "HighRisk" | "NotSet" | "OnTime" | "%future added value";
export type Track = "Discharge" | "Progression" | "%future added value";
export type VisitStatus = "Admitted" | "Discharged" | "PreAdmission" | "%future added value";
export type PatientPlanGQLQueryVariables = {|
  id: string
|};
export type PatientPlanGQLQueryResponse = {|
  +userSetting: ?{|
    +barriers: $ReadOnlyArray<{|
      +id: string,
      +name: ?string,
      +description: ?string,
      +active: ?boolean,
      +category: ?{|
        +code: ?string,
        +value: ?string,
      |},
      +templateId: ?any,
    |}>,
    +actions: $ReadOnlyArray<{|
      +id: string,
      +text: ?string,
    |}>,
    +notes: $ReadOnlyArray<{|
      +id: string,
      +text: ?string,
    |}>,
  |},
  +barrierEscalationRoles: ?$ReadOnlyArray<?{|
    +code: string,
    +value: string,
    +ordinal: number,
    +active: boolean,
  |}>,
  +deliveryMethods: ?$ReadOnlyArray<?{|
    +code: string,
    +active: boolean,
  |}>,
  +node: ?{|
    +id?: string,
    +vector?: ?{|
      +id: string,
      +patientId: string,
      +encounterId: string,
      +predictionDate: any,
      +conditions: ?$ReadOnlyArray<?{|
        +name: string,
        +description: string,
        +riskBracket: ?string,
        +riskFactors: $ReadOnlyArray<?{|
          +id: string,
          +type: string,
          +description: string,
        |}>,
        +recommendations: $ReadOnlyArray<?{|
          +id: string,
          +rank: string,
          +description: string,
          +code: string,
          +accepted: ?boolean,
        |}>,
      |}>,
    |},
    +bed?: ?{|
      +id: string,
      +status: string,
      +name: string,
      +department: {|
        +id: string,
        +exchangeName: string,
        +name: string,
        +type: DepartmentType,
        +includedInLosCalculation: boolean,
      |},
      +exchangeName: string,
    |},
    +admissionTime?: ?any,
    +admissionType?: ?AdmissionType,
    +admittingComplaint?: ?string,
    +admittingPhysician?: ?{|
      +firstName: ?string,
      +id: string,
      +lastName: ?string,
      +primary: boolean,
      +role: {|
        +code: ?string,
        +id: string,
        +value: ?string,
      |},
    |},
    +anticipatedDischargeTime?: ?any,
    +anticipatedDischargeUpdatedWhen?: ?any,
    +anticipatedDischargeUpdatedBy?: ?{|
      +userName: string,
      +firstName: string,
      +lastName: string,
    |},
    +attendingPhysician?: ?{|
      +firstName: ?string,
      +id: string,
      +lastName: ?string,
      +primary: boolean,
      +role: {|
        +code: ?string,
        +id: string,
        +value: ?string,
      |},
    |},
    +bedRequestStatus?: ?BedRequestStatus,
    +bedRequests?: $ReadOnlyArray<{|
      +id: string,
      +bedRequestType: BedRequestType,
      +bedRequestStatus: BedRequestStatus,
      +updatedWhen: any,
      +bedExchangeName: ?string,
    |}>,
    +consultingPhysicians?: $ReadOnlyArray<{|
      +id: string,
      +firstName: ?string,
      +lastName: ?string,
      +role: {|
        +id: string,
        +code: ?string,
        +value: ?string,
      |},
      +primary: boolean,
    |}>,
    +currentDayOfStay?: ?number,
    +decisionTime?: ?any,
    +decisionTimeEditable?: boolean,
    +decisionTimeUseMidnight?: boolean,
    +dischargeVendor?: ?string,
    +drgAttributes?: ?{|
      +id: string,
      +arithmeticLos: ?any,
      +code: string,
      +commonPrincipalDX: ?string,
      +commonProcedures: ?string,
      +expectedLos: any,
      +geometricLos: any,
      +level: string,
      +modifyTargetLos: boolean,
      +majorDiagnosisCategory: ?string,
      +readmissionRisk: ?boolean,
      +targetLos: number,
      +title: string,
      +type: ?string,
      +weight: ?any,
    |},
    +drgUpdatedBy?: ?{|
      +id: string,
      +firstName: string,
      +lastName: string,
      +userName: string,
    |},
    +drgUpdatedWhen?: ?any,
    +homeBedExchangeName?: ?string,
    +insurancePlans?: $ReadOnlyArray<{|
      +id: string,
      +planName: string,
      +priority: any,
      +cms: boolean,
    |}>,
    +meta?: {|
      +id: string,
      +decisionDue: boolean,
      +dischargeToday: boolean,
      +plannedDischargeExceeded: boolean,
      +timeElapsedSinceAdmission: any,
      +tlosExceeded: boolean,
    |},
    +patient?: {|
      +id: string,
      +age: ?string,
      +firstName: ?string,
      +gender: ?string,
      +lastName: ?string,
      +middleInitial: ?string,
      +mrn: ?string,
      +language: ?{|
        +code: ?string,
        +defaultValue: ?string,
      |},
    |},
    +patientAlerts?: $ReadOnlyArray<?{|
      +id: string,
      +alertType: string,
      +value: string,
    |}>,
    +patientProblem?: ?string,
    +provider1?: ?{|
      +id: string,
      +firstName: ?string,
      +lastName: ?string,
      +role: {|
        +code: ?string,
        +id: string,
        +value: ?string,
      |},
    |},
    +provider2?: ?{|
      +id: string,
      +firstName: ?string,
      +lastName: ?string,
      +role: {|
        +code: ?string,
        +id: string,
        +value: ?string,
      |},
    |},
    +readmission?: ?boolean,
    +readmissionUpdatedWhen?: ?any,
    +readmissionVerifiedBy?: ?{|
      +userName: string,
      +firstName: string,
      +lastName: string,
    |},
    +readmissionRisk?: ?boolean,
    +readmissionRiskUpdatedWhen?: ?any,
    +readmissionRiskVerifiedBy?: ?{|
      +userName: string,
      +firstName: string,
      +lastName: string,
    |},
    +targetDischargeTime?: ?any,
    +tlos?: ?number,
    +visitNumber?: ?string,
    +visitStatus?: VisitStatus,
    +workingDischargeDisposition?: ?{|
      +code: ?string,
      +id: string,
      +value: ?string,
    |},
    +plan?: ?{|
      +id: string,
      +actions: $ReadOnlyArray<?{|
        +id: string,
        +__typename: string,
        +text: string,
        +pinned: boolean,
        +status: ActionStatus,
        +auditMeta: ?{|
          +createdBy: {|
            +id: string,
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +updatedBy: {|
            +id: string,
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +created: any,
          +updated: any,
        |},
      |}>,
      +appliedTemplates: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +description: string,
        +documentURL: ?string,
        +removed: boolean,
      |}>,
      +barriers: $ReadOnlyArray<?{|
        +id: string,
        +__typename: string,
        +name: string,
        +description: string,
        +dischargeDelay: ?boolean,
        +pinned: boolean,
        +status: BarrierStatus,
        +category: {|
          +id: string,
          +code: string,
          +value: string,
          +sourceTypes: ?$ReadOnlyArray<?{|
            +id: string,
            +code: string,
            +value: string,
            +active: boolean,
            +activeDirectorySourceName: boolean,
            +hasConfiguredList: boolean,
            +sourceDetails: ?$ReadOnlyArray<?{|
              +id: string,
              +code: string,
              +value: string,
              +active: boolean,
            |}>,
          |}>,
        |},
        +escalation: ?{|
          +id: string,
          +auditMeta: ?{|
            +createdBy: {|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +updatedBy: {|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +created: any,
            +updated: any,
          |},
        |},
        +auditMeta: ?{|
          +createdBy: {|
            +id: string,
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +updatedBy: {|
            +id: string,
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +created: any,
          +updated: any,
        |},
        +ownerMessageStatus: ?OwnerMessageStatus,
        +ownerMessageStatusDate: ?any,
        +ownerKnownUser: ?{|
          +id: string,
          +emailReceiver: boolean,
          +instantMessageReceiver: boolean,
        |},
        +ownerMessageDeliveryDate: ?any,
        +owner: ?string,
        +ownerRole: ?{|
          +id: string,
          +code: ?string,
          +value: ?string,
        |},
        +sourceTypeCode: ?string,
        +sourceName: ?string,
        +notes: ?$ReadOnlyArray<?{|
          +id: string,
          +__typename: string,
          +text: string,
          +pinned: boolean,
          +auditMeta: ?{|
            +createdBy: {|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +updatedBy: {|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +created: any,
            +updated: any,
          |},
        |}>,
      |}>,
      +careTeamMembers: $ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
        +role: {|
          +id: string,
          +code: ?string,
          +value: ?string,
        |},
        +primary: ?boolean,
      |}>,
      +meta: ?{|
        +milestoneMeta: {|
          +overdue: any,
          +onTime: any,
          +completed: any,
        |},
        +lengthOfStayMeta: {|
          +forecast: ?any,
          +cappedForecast: ?any,
        |},
        +actualOE: ?number,
      |},
      +milestones: $ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +description: ?string,
        +dueDate: ?any,
        +dueDateCutoff: boolean,
        +track: ?Track,
        +duplicate: boolean,
        +status: MilestoneStatus,
        +actions: $ReadOnlyArray<?{|
          +id: string,
          +__typename: string,
          +pinned: boolean,
          +text: string,
          +status: ActionStatus,
          +milestoneTemplateName: ?string,
          +auditMeta: ?{|
            +createdBy: {|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +updatedBy: {|
              +id: string,
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +created: any,
            +updated: any,
          |},
        |}>,
        +offset: ?{|
          +basis: ?OffsetBasis,
          +days: ?number,
          +hours: ?number,
          +minutes: ?number,
        |},
        +planTemplateName: string,
      |}>,
      +notes: $ReadOnlyArray<?{|
        +id: string,
        +__typename: string,
        +text: string,
        +pinned: boolean,
        +auditMeta: ?{|
          +createdBy: {|
            +id: string,
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +updatedBy: {|
            +id: string,
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +created: any,
          +updated: any,
        |},
      |}>,
      +progressionIndicator: ProgressionIndicator,
      +toBeAdmitted: ?boolean,
    |},
    +anticipatedTransferTime?: ?any,
    +anticipatedDischargeTimeAutoPopulated?: ?boolean,
    +anticipatedTransferTimeAutoPopulated?: ?boolean,
  |},
|};
export type PatientPlanGQLQuery = {|
  variables: PatientPlanGQLQueryVariables,
  response: PatientPlanGQLQueryResponse,
|};
*/


/*
query PatientPlanGQLQuery(
  $id: ID!
) {
  userSetting {
    barriers {
      id
      name
      description
      active
      category {
        code
        value
        id
      }
      templateId
    }
    actions {
      id
      text
    }
    notes {
      id
      text
    }
  }
  barrierEscalationRoles: codeTables(codeTableType: BarrierEscalationRole) {
    code
    value
    ordinal
    active
    id
  }
  deliveryMethods: codeTables(codeTableType: DeliveryMethod) {
    code
    active
    id
  }
  node(id: $id) {
    __typename
    ... on Visit {
      id
      vector {
        id
        patientId
        encounterId
        predictionDate
        conditions {
          name
          description
          riskBracket
          riskFactors {
            id
            type
            description
          }
          recommendations {
            id
            rank
            description
            code
            accepted
          }
        }
      }
      bed {
        id
        status
        name
        department {
          id
          exchangeName
          name
          type
          includedInLosCalculation
        }
        exchangeName
      }
      admissionTime
      admissionType
      admittingComplaint
      admittingPhysician {
        firstName
        id
        lastName
        primary
        role {
          code
          id
          value
        }
      }
      anticipatedDischargeTime
      anticipatedDischargeUpdatedWhen
      anticipatedDischargeUpdatedBy {
        userName
        firstName
        lastName
        id
      }
      attendingPhysician {
        firstName
        id
        lastName
        primary
        role {
          code
          id
          value
        }
      }
      bedRequestStatus
      bedRequests {
        id
        bedRequestType
        bedRequestStatus
        updatedWhen
        bedExchangeName
      }
      consultingPhysicians {
        id
        firstName
        lastName
        role {
          id
          code
          value
        }
        primary
      }
      currentDayOfStay
      decisionTime
      decisionTimeEditable
      decisionTimeUseMidnight
      dischargeVendor
      drgAttributes {
        id
        arithmeticLos
        code
        commonPrincipalDX
        commonProcedures
        expectedLos
        geometricLos
        level
        modifyTargetLos
        majorDiagnosisCategory
        readmissionRisk
        targetLos
        title
        type
        weight
      }
      drgUpdatedBy {
        id
        firstName
        lastName
        userName
      }
      drgUpdatedWhen
      homeBedExchangeName
      insurancePlans {
        id
        planName
        priority
        cms
      }
      meta {
        id
        decisionDue
        dischargeToday
        plannedDischargeExceeded
        timeElapsedSinceAdmission
        tlosExceeded
      }
      patient {
        id
        age
        firstName
        gender
        lastName
        middleInitial
        mrn
        language {
          code
          defaultValue
        }
      }
      patientAlerts {
        id
        alertType
        value
      }
      patientProblem
      provider1 {
        id
        firstName
        lastName
        role {
          code
          id
          value
        }
      }
      provider2 {
        id
        firstName
        lastName
        role {
          code
          id
          value
        }
      }
      readmission
      readmissionUpdatedWhen
      readmissionVerifiedBy {
        userName
        firstName
        lastName
        id
      }
      readmissionRisk
      readmissionRiskUpdatedWhen
      readmissionRiskVerifiedBy {
        userName
        firstName
        lastName
        id
      }
      targetDischargeTime
      tlos
      visitNumber
      visitStatus
      workingDischargeDisposition {
        code
        id
        value
      }
      plan {
        id
        actions {
          id
          __typename
          text
          pinned
          status
          auditMeta {
            createdBy {
              id
              userName
              firstName
              lastName
            }
            updatedBy {
              id
              userName
              firstName
              lastName
            }
            created
            updated
          }
        }
        appliedTemplates {
          id
          name
          description
          documentURL
          removed
        }
        barriers {
          id
          __typename
          name
          description
          dischargeDelay
          pinned
          status
          category {
            id
            code
            value
            sourceTypes {
              id
              code
              value
              active
              activeDirectorySourceName
              hasConfiguredList
              sourceDetails {
                id
                code
                value
                active
              }
            }
          }
          escalation {
            id
            auditMeta {
              createdBy {
                id
                userName
                firstName
                lastName
              }
              updatedBy {
                id
                userName
                firstName
                lastName
              }
              created
              updated
            }
          }
          auditMeta {
            createdBy {
              id
              userName
              firstName
              lastName
            }
            updatedBy {
              id
              userName
              firstName
              lastName
            }
            created
            updated
          }
          ownerMessageStatus
          ownerMessageStatusDate
          ownerKnownUser {
            id
            emailReceiver
            instantMessageReceiver
          }
          ownerMessageDeliveryDate
          owner
          ownerRole {
            id
            code
            value
          }
          sourceTypeCode
          sourceName
          notes {
            id
            __typename
            text
            pinned
            auditMeta {
              createdBy {
                id
                userName
                firstName
                lastName
              }
              updatedBy {
                id
                userName
                firstName
                lastName
              }
              created
              updated
            }
          }
        }
        careTeamMembers {
          id
          name
          role {
            id
            code
            value
          }
          primary
        }
        meta {
          milestoneMeta {
            overdue
            onTime
            completed
          }
          lengthOfStayMeta {
            forecast
            cappedForecast
          }
          actualOE
        }
        milestones {
          id
          name
          description
          dueDate
          dueDateCutoff
          track
          duplicate
          status
          actions {
            id
            __typename
            pinned
            text
            status
            milestoneTemplateName
            auditMeta {
              createdBy {
                id
                userName
                firstName
                lastName
              }
              updatedBy {
                id
                userName
                firstName
                lastName
              }
              created
              updated
            }
          }
          offset {
            basis
            days
            hours
            minutes
          }
          planTemplateName
        }
        notes {
          id
          __typename
          text
          pinned
          auditMeta {
            createdBy {
              id
              userName
              firstName
              lastName
            }
            updatedBy {
              id
              userName
              firstName
              lastName
            }
            created
            updated
          }
        }
        progressionIndicator
        toBeAdmitted
      }
      anticipatedTransferTime
      anticipatedDischargeTimeAutoPopulated
      anticipatedTransferTimeAutoPopulated
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v9 = [
  (v1/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "FavoriteAction",
  "kind": "LinkedField",
  "name": "actions",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "FavoriteNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "codeTableType",
    "value": "BarrierEscalationRole"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "codeTableType",
    "value": "DeliveryMethod"
  }
],
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientVector",
  "kind": "LinkedField",
  "name": "vector",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "encounterId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "predictionDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientCondition",
      "kind": "LinkedField",
      "name": "conditions",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "riskBracket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientRiskFactor",
          "kind": "LinkedField",
          "name": "riskFactors",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v16/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PatientRecommendation",
          "kind": "LinkedField",
          "name": "recommendations",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rank",
              "storageKey": null
            },
            (v3/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accepted",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Bed",
  "kind": "LinkedField",
  "name": "bed",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v18/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Department",
      "kind": "LinkedField",
      "name": "department",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v19/*: any*/),
        (v2/*: any*/),
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includedInLosCalculation",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admissionTime",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admissionType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "admittingComplaint",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primary",
  "storageKey": null
},
v27 = [
  (v5/*: any*/),
  (v1/*: any*/),
  (v6/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "CodeTablePair",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v29 = [
  (v24/*: any*/),
  (v1/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "admittingPhysician",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedDischargeTime",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedDischargeUpdatedWhen",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v34 = [
  (v33/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "attendingPhysician",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bedRequestStatus",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "BedRequest",
  "kind": "LinkedField",
  "name": "bedRequests",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bedRequestType",
      "storageKey": null
    },
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedWhen",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bedExchangeName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = [
  (v1/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "CodeTablePair",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "consultingPhysicians",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v39/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentDayOfStay",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTime",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTimeEditable",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decisionTimeUseMidnight",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeVendor",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readmissionRisk",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "DrgAttributes",
  "kind": "LinkedField",
  "name": "drgAttributes",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arithmeticLos",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commonPrincipalDX",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commonProcedures",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expectedLos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geometricLos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modifyTargetLos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "majorDiagnosisCategory",
      "storageKey": null
    },
    (v46/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetLos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "drgUpdatedBy",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "drgUpdatedWhen",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "homeBedExchangeName",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "InsurancePlan",
  "kind": "LinkedField",
  "name": "insurancePlans",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cms",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "VisitMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decisionDue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dischargeToday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDischargeExceeded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeElapsedSinceAdmission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tlosExceeded",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Patient",
  "kind": "LinkedField",
  "name": "patient",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "middleInitial",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mrn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "language",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientAlert",
  "kind": "LinkedField",
  "name": "patientAlerts",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertType",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientProblem",
  "storageKey": null
},
v56 = [
  (v1/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v28/*: any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "provider1",
  "plural": false,
  "selections": (v56/*: any*/),
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "provider2",
  "plural": false,
  "selections": (v56/*: any*/),
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readmission",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readmissionUpdatedWhen",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readmissionRiskUpdatedWhen",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetDischargeTime",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tlos",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitNumber",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitStatus",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkingDischargeDispositionDTO",
  "kind": "LinkedField",
  "name": "workingDischargeDisposition",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v69 = [
  (v1/*: any*/),
  (v33/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v69/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v69/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = [
  (v1/*: any*/),
  (v67/*: any*/),
  (v8/*: any*/),
  (v68/*: any*/),
  (v70/*: any*/)
],
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "Plan",
  "kind": "LinkedField",
  "name": "plan",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PlanAction",
      "kind": "LinkedField",
      "name": "actions",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v67/*: any*/),
        (v8/*: any*/),
        (v68/*: any*/),
        (v18/*: any*/),
        (v70/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TemplateInfo",
      "kind": "LinkedField",
      "name": "appliedTemplates",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentURL",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "removed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Barrier",
      "kind": "LinkedField",
      "name": "barriers",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v67/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dischargeDelay",
          "storageKey": null
        },
        (v68/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BarrierCategory",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "BarrierSourceType",
              "kind": "LinkedField",
              "name": "sourceTypes",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activeDirectorySourceName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasConfiguredList",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BarrierSourceDetail",
                  "kind": "LinkedField",
                  "name": "sourceDetails",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Escalation",
          "kind": "LinkedField",
          "name": "escalation",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v70/*: any*/)
          ],
          "storageKey": null
        },
        (v70/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ownerMessageStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ownerMessageStatusDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KnownUser",
          "kind": "LinkedField",
          "name": "ownerKnownUser",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailReceiver",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "instantMessageReceiver",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ownerMessageDeliveryDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "owner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CodeTablePair",
          "kind": "LinkedField",
          "name": "ownerRole",
          "plural": false,
          "selections": (v38/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceTypeCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BarrierNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": (v71/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CareTeamMember",
      "kind": "LinkedField",
      "name": "careTeamMembers",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v39/*: any*/),
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlanMeta",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MilestoneMeta",
          "kind": "LinkedField",
          "name": "milestoneMeta",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "overdue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "completed",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LengthOfStayMeta",
          "kind": "LinkedField",
          "name": "lengthOfStayMeta",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cappedForecast",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualOE",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Milestone",
      "kind": "LinkedField",
      "name": "milestones",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dueDateCutoff",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "track",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duplicate",
          "storageKey": null
        },
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MilestoneAction",
          "kind": "LinkedField",
          "name": "actions",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v67/*: any*/),
            (v68/*: any*/),
            (v8/*: any*/),
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "milestoneTemplateName",
              "storageKey": null
            },
            (v70/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Offset",
          "kind": "LinkedField",
          "name": "offset",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "basis",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "days",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hours",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutes",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planTemplateName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlanNote",
      "kind": "LinkedField",
      "name": "notes",
      "plural": true,
      "selections": (v71/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressionIndicator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toBeAdmitted",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedTransferTime",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedDischargeTimeAutoPopulated",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anticipatedTransferTimeAutoPopulated",
  "storageKey": null
},
v76 = [
  (v33/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PatientPlanGQLQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserSetting",
        "kind": "LinkedField",
        "name": "userSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FavoriteBarrier",
            "kind": "LinkedField",
            "name": "barriers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CodeTablePair",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "barrierEscalationRoles",
        "args": (v12/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v13/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": "codeTables(codeTableType:\"BarrierEscalationRole\")"
      },
      {
        "alias": "deliveryMethods",
        "args": (v14/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": "codeTables(codeTableType:\"DeliveryMethod\")"
      },
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              (v17/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuditUser",
                "kind": "LinkedField",
                "name": "anticipatedDischargeUpdatedBy",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuditUser",
                "kind": "LinkedField",
                "name": "readmissionVerifiedBy",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              (v46/*: any*/),
              (v61/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuditUser",
                "kind": "LinkedField",
                "name": "readmissionRiskVerifiedBy",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": null
              },
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/)
            ],
            "type": "Visit",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PatientPlanGQLQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserSetting",
        "kind": "LinkedField",
        "name": "userSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FavoriteBarrier",
            "kind": "LinkedField",
            "name": "barriers",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CodeTablePair",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "barrierEscalationRoles",
        "args": (v12/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v13/*: any*/),
          (v4/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": "codeTables(codeTableType:\"BarrierEscalationRole\")"
      },
      {
        "alias": "deliveryMethods",
        "args": (v14/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": "codeTables(codeTableType:\"DeliveryMethod\")"
      },
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v67/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuditUser",
                "kind": "LinkedField",
                "name": "anticipatedDischargeUpdatedBy",
                "plural": false,
                "selections": (v76/*: any*/),
                "storageKey": null
              },
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuditUser",
                "kind": "LinkedField",
                "name": "readmissionVerifiedBy",
                "plural": false,
                "selections": (v76/*: any*/),
                "storageKey": null
              },
              (v46/*: any*/),
              (v61/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuditUser",
                "kind": "LinkedField",
                "name": "readmissionRiskVerifiedBy",
                "plural": false,
                "selections": (v76/*: any*/),
                "storageKey": null
              },
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/)
            ],
            "type": "Visit",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4f6ba5f207eba14eee8d59bede4efc67",
    "id": null,
    "metadata": {},
    "name": "PatientPlanGQLQuery",
    "operationKind": "query",
    "text": "query PatientPlanGQLQuery(\n  $id: ID!\n) {\n  userSetting {\n    barriers {\n      id\n      name\n      description\n      active\n      category {\n        code\n        value\n        id\n      }\n      templateId\n    }\n    actions {\n      id\n      text\n    }\n    notes {\n      id\n      text\n    }\n  }\n  barrierEscalationRoles: codeTables(codeTableType: BarrierEscalationRole) {\n    code\n    value\n    ordinal\n    active\n    id\n  }\n  deliveryMethods: codeTables(codeTableType: DeliveryMethod) {\n    code\n    active\n    id\n  }\n  node(id: $id) {\n    __typename\n    ... on Visit {\n      id\n      vector {\n        id\n        patientId\n        encounterId\n        predictionDate\n        conditions {\n          name\n          description\n          riskBracket\n          riskFactors {\n            id\n            type\n            description\n          }\n          recommendations {\n            id\n            rank\n            description\n            code\n            accepted\n          }\n        }\n      }\n      bed {\n        id\n        status\n        name\n        department {\n          id\n          exchangeName\n          name\n          type\n          includedInLosCalculation\n        }\n        exchangeName\n      }\n      admissionTime\n      admissionType\n      admittingComplaint\n      admittingPhysician {\n        firstName\n        id\n        lastName\n        primary\n        role {\n          code\n          id\n          value\n        }\n      }\n      anticipatedDischargeTime\n      anticipatedDischargeUpdatedWhen\n      anticipatedDischargeUpdatedBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n      attendingPhysician {\n        firstName\n        id\n        lastName\n        primary\n        role {\n          code\n          id\n          value\n        }\n      }\n      bedRequestStatus\n      bedRequests {\n        id\n        bedRequestType\n        bedRequestStatus\n        updatedWhen\n        bedExchangeName\n      }\n      consultingPhysicians {\n        id\n        firstName\n        lastName\n        role {\n          id\n          code\n          value\n        }\n        primary\n      }\n      currentDayOfStay\n      decisionTime\n      decisionTimeEditable\n      decisionTimeUseMidnight\n      dischargeVendor\n      drgAttributes {\n        id\n        arithmeticLos\n        code\n        commonPrincipalDX\n        commonProcedures\n        expectedLos\n        geometricLos\n        level\n        modifyTargetLos\n        majorDiagnosisCategory\n        readmissionRisk\n        targetLos\n        title\n        type\n        weight\n      }\n      drgUpdatedBy {\n        id\n        firstName\n        lastName\n        userName\n      }\n      drgUpdatedWhen\n      homeBedExchangeName\n      insurancePlans {\n        id\n        planName\n        priority\n        cms\n      }\n      meta {\n        id\n        decisionDue\n        dischargeToday\n        plannedDischargeExceeded\n        timeElapsedSinceAdmission\n        tlosExceeded\n      }\n      patient {\n        id\n        age\n        firstName\n        gender\n        lastName\n        middleInitial\n        mrn\n        language {\n          code\n          defaultValue\n        }\n      }\n      patientAlerts {\n        id\n        alertType\n        value\n      }\n      patientProblem\n      provider1 {\n        id\n        firstName\n        lastName\n        role {\n          code\n          id\n          value\n        }\n      }\n      provider2 {\n        id\n        firstName\n        lastName\n        role {\n          code\n          id\n          value\n        }\n      }\n      readmission\n      readmissionUpdatedWhen\n      readmissionVerifiedBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n      readmissionRisk\n      readmissionRiskUpdatedWhen\n      readmissionRiskVerifiedBy {\n        userName\n        firstName\n        lastName\n        id\n      }\n      targetDischargeTime\n      tlos\n      visitNumber\n      visitStatus\n      workingDischargeDisposition {\n        code\n        id\n        value\n      }\n      plan {\n        id\n        actions {\n          id\n          __typename\n          text\n          pinned\n          status\n          auditMeta {\n            createdBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            updatedBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            created\n            updated\n          }\n        }\n        appliedTemplates {\n          id\n          name\n          description\n          documentURL\n          removed\n        }\n        barriers {\n          id\n          __typename\n          name\n          description\n          dischargeDelay\n          pinned\n          status\n          category {\n            id\n            code\n            value\n            sourceTypes {\n              id\n              code\n              value\n              active\n              activeDirectorySourceName\n              hasConfiguredList\n              sourceDetails {\n                id\n                code\n                value\n                active\n              }\n            }\n          }\n          escalation {\n            id\n            auditMeta {\n              createdBy {\n                id\n                userName\n                firstName\n                lastName\n              }\n              updatedBy {\n                id\n                userName\n                firstName\n                lastName\n              }\n              created\n              updated\n            }\n          }\n          auditMeta {\n            createdBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            updatedBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            created\n            updated\n          }\n          ownerMessageStatus\n          ownerMessageStatusDate\n          ownerKnownUser {\n            id\n            emailReceiver\n            instantMessageReceiver\n          }\n          ownerMessageDeliveryDate\n          owner\n          ownerRole {\n            id\n            code\n            value\n          }\n          sourceTypeCode\n          sourceName\n          notes {\n            id\n            __typename\n            text\n            pinned\n            auditMeta {\n              createdBy {\n                id\n                userName\n                firstName\n                lastName\n              }\n              updatedBy {\n                id\n                userName\n                firstName\n                lastName\n              }\n              created\n              updated\n            }\n          }\n        }\n        careTeamMembers {\n          id\n          name\n          role {\n            id\n            code\n            value\n          }\n          primary\n        }\n        meta {\n          milestoneMeta {\n            overdue\n            onTime\n            completed\n          }\n          lengthOfStayMeta {\n            forecast\n            cappedForecast\n          }\n          actualOE\n        }\n        milestones {\n          id\n          name\n          description\n          dueDate\n          dueDateCutoff\n          track\n          duplicate\n          status\n          actions {\n            id\n            __typename\n            pinned\n            text\n            status\n            milestoneTemplateName\n            auditMeta {\n              createdBy {\n                id\n                userName\n                firstName\n                lastName\n              }\n              updatedBy {\n                id\n                userName\n                firstName\n                lastName\n              }\n              created\n              updated\n            }\n          }\n          offset {\n            basis\n            days\n            hours\n            minutes\n          }\n          planTemplateName\n        }\n        notes {\n          id\n          __typename\n          text\n          pinned\n          auditMeta {\n            createdBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            updatedBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            created\n            updated\n          }\n        }\n        progressionIndicator\n        toBeAdmitted\n      }\n      anticipatedTransferTime\n      anticipatedDischargeTimeAutoPopulated\n      anticipatedTransferTimeAutoPopulated\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e4b0be43cb17a143e5487bdb009cf789';

module.exports = node;
